<template>
  <form name="form">
    <b-modal id="SetNewPassword" hide-footer size="xl">
      <template #modal-title> Zmiana hasła </template>

      <div class="row">
        <div class="col">
          <label for="ProducerName" class="form-label">Nazwa Konta</label>
          <input
            type="text"
            class="form-control"
            id="userName"
            v-model="user.name"
            disabled="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="password" class="form-label">Nowe hasło</label>
          <input
            type="password"
            class="form-control"
            id="password"
            v-model="password"
          />
        </div>
        <div class="col-6">
          <label for="confirmPassword" class="form-label"
            >Potwierdź nowe hasło</label
          >
          <input
            type="password"
            class="form-control"
            id="confirmPassword"
            v-model="confirmPassword"
          />
        </div>
      </div>

      <div class="row">
        <div class="col" v-if="!isPasswordsAreEqual">
          <small class="color-red">Hasłą nie są jednakowe</small>
        </div>
      </div>

      <div class="col align-self-end div-form-buttons-area">
        <button class="btn btn-primary" type="button" @click="SaveData">
          Zapisz
        </button>
        <button
          class="btn btn-warning"
          type="button"
          @click="ClearFormAndCloseWindow"
        >
          Zamknij
        </button>
      </div>
    </b-modal>
  </form>
</template>

<script>
import urlConfig from "../../../../mixins/url";
import toastr from "../../../../mixins/toastr";
import UserService from "../../../../services/user.service";

export default {
  components: {},
  mixins: [urlConfig, toastr],
  props: ["user"],
  mounted() {
    this.$root.$on("bv::modal::hide", () => {
      this.form = {
        userId: 0,
        password: "",
        confirmPassword: "",
      };
      this.formErrors = [];
    });
  },
  watch: {
    password(value) {
      this.isPasswordsAreEqual = this.password == this.confirmPassword;
      this.form.password = value;
      return this.password;
    },
    confirmPassword(value) {
      this.isPasswordsAreEqual = this.password == this.confirmPassword;
      this.form.confirmPassword = value;
      return this.confirmPassword;
    },
  },
  data() {
    return {
      password: "",
      confirmPassword: "",

      isPasswordsAreEqual: true,
    };
  },
  methods: {
    ClearFormAndCloseWindow() {
      this.$bvModal.hide("SetNewPassword");
    },
    SaveData() {
      var that = this;
      if (this.isPasswordsAreEqual) {
        UserService.changePassword(this.user.id, this.password)
          .then(() => {
            that.DisplaySuccess(
              "Sukces!",
              "Hasło dla konta " + that.user.name + " zostało zmienione"
            );
            this.$bvModal.hide("SetNewPassword");
          })
          .catch((err) => {
            that.DisplayError("Błąd!", err);
          });
      }
    },
  },
};
</script>